import AccountService from "@/services/AccountService";
export default {
  namespaced: true,
  state: {
    rooms: []
  },
  mutations: {
    saveRooms(state, rooms) {
      state.rooms = [...rooms];
    }
  },
  actions: {
    async createRoom({rootState, dispatch}, {username, roomId, maxParty, pool, template}) {
      const token = rootState.auth.token;
      try {
        const res = await AccountService.createRoom({ username, roomId, maxParty, pool, template }, token);
        if (res.data.status) {
          await dispatch('fetchRoomList')
        }
        return res;
      } catch (err) {
        throw new Error(err);
      }
    },
    async deleteRoom({rootState, dispatch}, {username, rooms}) {
      const token = rootState.auth.token;
      try {
        const res = await AccountService.deleteRoom({ username, rooms }, token);
        if (res.data.status) {
          await dispatch('fetchRoomList')
        }
        return res;
      } catch (err) {
        throw new Error(err);
      }
    },
    async fetchRoomList({ commit, rootState }) {
      const token = rootState.auth.token;
      const username = rootState.auth.username;
      try {
        const res = await AccountService.fetchRoomList({ username }, token);
        if (res.data.status) {
          commit("saveRooms", res.data.rooms);
        }
        return res;
      } catch (err) {
        throw new Error(err);
      }
    },
    async updateRoom({ rootState, dispatch }, data) {
      const token = rootState.auth.token;
      try {
        const res = await AccountService.updateRoom(data, token);
        if (res.data.status) {
          await dispatch('fetchRoomList')
        }
        return res;
      } catch (err) {
        throw new Error(err);
      }
    },
  }
};
